<!-- 支付失败 -->

<template>
    <div class="pay-fail">
        <app-header            
            @on-click="goBack"
        ></app-header>

        <div class="icon-box">
            <img src="../../assets/imgs/fail.png">
            <div class="text">{{ $t('pay.fail.payment_fail') }}</div>
            <div class="tip">{{ $t('pay.fail.payment_fail_desc') }}</div>
        </div>
        <div class="btns">
            <div class="btn back-to-home-btn" @click="goBack">{{ $t('pay.fail.back_home') }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PayFail',
        methods: {
            goBack() {
                this.$router.push(this.$setRouteQuery({path: '/'},this))
            }
        }
    }
</script>

<style lang="less" scoped>
    @import 'css/fail.less';
</style>